import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { AUTOCALLER_URL } from '@shared/helpers/env';
class MonitoringServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }
  getList(campaign_id, params = {}) {
    return this.http.get(`${campaign_id}/status`, { params: params });
  }
}

export const MonitoringService = new MonitoringServiceClass({
  api_version: 1,
  base_url: AUTOCALLER_URL,
  resource: 'campaigns'
});
